var avatarImageCache = new Map();
var avatarImageLoadPromises = new Map();
var PRELOAD_CONTAINER_ID = 'communication-chart-avatar-preload';
var resolveAbsoluteAvatarUrl = function (url) {
    if (typeof window === 'undefined') {
        return url;
    }
    try {
        return new URL(url, window.location.origin).href;
    }
    catch (_a) {
        return url;
    }
};
export var normalizeCommunicationChartAvatarUrl = function (url) {
    return resolveAbsoluteAvatarUrl(url.trim());
};
var cacheLoadedAvatarImage = function (normalizedUrl, image) {
    var _a;
    if (image.naturalWidth <= 0) {
        return null;
    }
    avatarImageCache.set(normalizedUrl, image);
    if (((_a = image.parentElement) === null || _a === void 0 ? void 0 : _a.id) === PRELOAD_CONTAINER_ID) {
        image.remove();
    }
    return image;
};
var getPreloadContainer = function () {
    if (typeof document === 'undefined') {
        return null;
    }
    var container = document.getElementById(PRELOAD_CONTAINER_ID);
    if (!container) {
        container = document.createElement('div');
        container.id = PRELOAD_CONTAINER_ID;
        container.setAttribute('aria-hidden', 'true');
        container.style.cssText =
            'position:absolute;width:0;height:0;overflow:hidden;visibility:hidden;pointer-events:none;';
        document.body.appendChild(container);
    }
    return container;
};
var findDomAvatarImage = function (normalizedUrl) {
    if (typeof document === 'undefined') {
        return undefined;
    }
    for (var _i = 0, _a = Array.from(document.images); _i < _a.length; _i++) {
        var image = _a[_i];
        if (image.src !== normalizedUrl) {
            continue;
        }
        if (image.complete && image.naturalWidth > 0) {
            return image;
        }
    }
    return undefined;
};
var findPreloadContainerImage = function (normalizedUrl) {
    var container = document.getElementById(PRELOAD_CONTAINER_ID);
    if (!container) {
        return undefined;
    }
    var image = container.querySelector("img[data-avatar-url=\"".concat(CSS.escape(normalizedUrl), "\"]"));
    if (!(image === null || image === void 0 ? void 0 : image.complete) || image.naturalWidth <= 0) {
        return undefined;
    }
    return image;
};
var loadAvatarImage = function (url, onAvatarLoad) {
    var _a;
    var normalizedUrl = normalizeCommunicationChartAvatarUrl(url);
    var cached = avatarImageCache.get(normalizedUrl);
    if ((cached === null || cached === void 0 ? void 0 : cached.complete) && cached.naturalWidth > 0) {
        return Promise.resolve(cached);
    }
    var domImage = (_a = findDomAvatarImage(normalizedUrl)) !== null && _a !== void 0 ? _a : findPreloadContainerImage(normalizedUrl);
    if (domImage) {
        return Promise.resolve(cacheLoadedAvatarImage(normalizedUrl, domImage));
    }
    var container = getPreloadContainer();
    if (!container) {
        return Promise.resolve(null);
    }
    return new Promise(function (resolve) {
        var settled = false;
        var finish = function (image) {
            if (settled) {
                return;
            }
            settled = true;
            var cachedImage = image
                ? cacheLoadedAvatarImage(normalizedUrl, image)
                : null;
            if (cachedImage) {
                onAvatarLoad === null || onAvatarLoad === void 0 ? void 0 : onAvatarLoad();
            }
            resolve(cachedImage);
        };
        var image = document.createElement('img');
        image.decoding = 'async';
        image.dataset.avatarUrl = normalizedUrl;
        image.onload = function () { return finish(image); };
        image.onerror = function () {
            image.remove();
            finish(null);
        };
        container.appendChild(image);
        image.src = normalizedUrl;
        if (image.complete && image.naturalWidth > 0) {
            finish(image);
        }
    });
};
export var preloadCommunicationChartAvatarImages = function (avatarUrls, options) {
    var uniqueUrls = Array.from(new Set(avatarUrls.filter(Boolean).map(normalizeCommunicationChartAvatarUrl)));
    return Promise.all(uniqueUrls.map(function (url) {
        return getCommunicationChartAvatarImage(url, options === null || options === void 0 ? void 0 : options.onAvatarLoad);
    })).then(function () { return undefined; });
};
export var getCommunicationChartAvatarImage = function (url, onAvatarLoad) {
    var _a;
    var normalizedUrl = normalizeCommunicationChartAvatarUrl(url);
    var cached = avatarImageCache.get(normalizedUrl);
    if ((cached === null || cached === void 0 ? void 0 : cached.complete) && cached.naturalWidth > 0) {
        return Promise.resolve(cached);
    }
    var domImage = (_a = findDomAvatarImage(normalizedUrl)) !== null && _a !== void 0 ? _a : findPreloadContainerImage(normalizedUrl);
    if (domImage) {
        cacheLoadedAvatarImage(normalizedUrl, domImage);
        return Promise.resolve(domImage);
    }
    var loading = avatarImageLoadPromises.get(normalizedUrl);
    if (loading) {
        return loading;
    }
    var promise = loadAvatarImage(url, onAvatarLoad).finally(function () {
        avatarImageLoadPromises.delete(normalizedUrl);
    });
    avatarImageLoadPromises.set(normalizedUrl, promise);
    return promise;
};
export var getLoadedCommunicationChartAvatarImage = function (url) {
    var normalizedUrl = normalizeCommunicationChartAvatarUrl(url);
    var cached = avatarImageCache.get(normalizedUrl);
    if ((cached === null || cached === void 0 ? void 0 : cached.complete) && cached.naturalWidth > 0) {
        return cached;
    }
    return undefined;
};
export var resetCommunicationChartAvatarImageCacheForTests = function () {
    var _a;
    avatarImageCache.clear();
    avatarImageLoadPromises.clear();
    (_a = document.getElementById(PRELOAD_CONTAINER_ID)) === null || _a === void 0 ? void 0 : _a.remove();
};
